// ---------------------------------------------------------------------------
// Formatting helpers.
//
// Currency wording and the contact details used by {{token}} hrefs both come
// from site_settings, so nothing here hardcodes a number or a currency.
// ---------------------------------------------------------------------------

/**
 * Reproduces the original design's formatting exactly:
 *   en → "EGP 2,800"      ar → "2,800 جنيه"
 */
export function formatMoney(amount, language, currencyLabel = 'EGP', locale = 'en-US') {
  const number = Number(amount ?? 0).toLocaleString(locale, { maximumFractionDigits: 2 });
  return language === 'ar' ? `${number} ${currencyLabel}` : `${currencyLabel} ${number}`;
}

/** Resolves {{phone}} / {{whatsapp}} tokens stored on content links. */
export function resolveHref(href, settings) {
  if (!href) return '#';
  const phone = settings?.['contact.phone'] ?? '';
  const whatsapp = settings?.['contact.whatsapp'] ?? '';

  if (href === '{{whatsapp}}') return whatsapp ? `https://wa.me/${whatsapp}` : '#';

  return href.replace('{{phone}}', phone).replace('{{whatsapp}}', whatsapp);
}

export const whatsappLink = (settings, message) => {
  const number = settings?.['contact.whatsapp'] ?? '';
  if (!number) return '#';
  return message ? `https://wa.me/${number}?text=${encodeURIComponent(message)}` : `https://wa.me/${number}`;
};

export const telLink = (settings) => `tel:${settings?.['contact.phone'] ?? ''}`;

/** Fills {placeholders} in a translated string. */
export const fill = (template, values = {}) =>
  String(template ?? '').replace(/\{(\w+)\}/g, (match, key) => (key in values ? String(values[key]) : match));

export function formatDate(value, language) {
  if (!value) return '';
  return new Date(value).toLocaleDateString(language === 'ar' ? 'ar-EG' : 'en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatDateTime(value, language) {
  if (!value) return '';
  return new Date(value).toLocaleString(language === 'ar' ? 'ar-EG' : 'en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Picks the right half of an { en, ar } pair. */
export const pick = (pair, language) => {
  if (pair == null) return '';
  if (typeof pair === 'string') return pair;
  return pair[language] || pair.en || '';
};
